<template>
    <div class="d-flex flex-wrap gap-y-3">
        <span class="d-block w-100 text-md text-arapawa font-weight-600">
            {{ $t('popup_reminder.unrenewed_service.title') }}
        </span>
        <div class="d-flex flex-wrap service__container">
            <a
                v-for="(service, index) in unrenewedServices"
                :key="index"
                :class="service.class"
                :href="service.url"
                class="
                    service__item
                    rounded-xl
                    px-semi-3
                    py-2
                    d-flex
                    align-items-center
                    justify-content-sm-center
                    gap-x-2s
                    border-1 border-white-smoke-5
                    bg-hover-athens-gray-4
                    shadow-none
                    text-arapawa text-hover-cinnabar
                "
                rel="noopener"
                target="_blank"
            >
                <img
                    :alt="service.label"
                    :src="service.icon"
                    class="w-36-px h-36-px"
                />
                <span
                    class="
                        text-arapawa text-hover-arapawa text-md
                        font-weight-600
                        ls-normal
                    "
                >
                    {{ service.label }} (x{{ service.value }})
                </span>
                <i class="far fa-chevron-right text-semi-sm icon-square"></i>
            </a>
        </div>
    </div>
</template>

<script>
import { PRODUCT_TYPE } from '@/constants/config';
import {
    DOMAIN_STATUS,
    PACKAGE_STATUS,
    SHARED_HOSTING_STATUS,
    SSL_STATUSES,
    WORDPRESS_HOSTING_STATUS,
} from '@/constants/status';

export default {
    name: 'UnrenewedServiceList',
    props: {
        items: {
            type: Array,
            required: true,
        },
    },
    computed: {
        unrenewedServices() {
            const generateServiceUrl = (name, query) => {
                const { href } = this.$router.resolve({
                    name,
                    query,
                });
                return href;
            };
            const getUnrenewedCountByType = (type) => {
                const service = this.items.find(
                    ({ productType }) => productType === type
                );
                return service?.count || 0;
            };
            const services = [
                {
                    label: this.$t('domain.domain'),
                    value: getUnrenewedCountByType(PRODUCT_TYPE.DOMAIN),
                    icon: require('@/assets/images/services/domain.svg'),
                    url: generateServiceUrl('domain.list', {
                        state: DOMAIN_STATUS.GRACE.key,
                    }),
                },
                {
                    label: this.$t('cloud-server.cloud_server'),
                    value: getUnrenewedCountByType(PRODUCT_TYPE.CLOUD_SERVER),
                    icon: require('@/assets/images/services/cloud-server.svg'),
                    url: generateServiceUrl('cloud-server.list', {
                        status: PACKAGE_STATUS.EXPIRED.key,
                    }),
                },
                {
                    label: this.$t('cloud-hosting.cloud_hosting'),
                    value: getUnrenewedCountByType(PRODUCT_TYPE.CLOUD_HOSTING),
                    icon: require('@/assets/images/services/cloud-hosting.svg'),
                    url: generateServiceUrl('cloud-hosting.list', {
                        status: PACKAGE_STATUS.EXPIRED.key,
                    }),
                },
                {
                    label: this.$t('wp_hosting.security.ssl_certificate.title'),
                    value: getUnrenewedCountByType(PRODUCT_TYPE.SSL),
                    icon: require('@/assets/images/services/ssl.svg'),
                    url: generateServiceUrl('ssl.list', {
                        status: SSL_STATUSES.EXPIRED.key,
                    }),
                },
                {
                    label: this.$t('wp_hosting.title'),
                    value: getUnrenewedCountByType(
                        PRODUCT_TYPE.WORDPRESS_HOSTING
                    ),
                    icon: require('@/assets/images/services/wp-hosting.svg'),
                    url: generateServiceUrl('wp-hosting.list', {
                        status: WORDPRESS_HOSTING_STATUS.EXPIRED.key,
                    }),
                },
                {
                    label: this.$t('shared_hosting.title'),
                    value: getUnrenewedCountByType(PRODUCT_TYPE.SHARED_HOSTING),
                    icon: require('@/assets/images/services/shared-hosting.svg'),
                    url: generateServiceUrl('shared-hosting.list', {
                        status: SHARED_HOSTING_STATUS.EXPIRED.key,
                    }),
                },
            ];
            return services.filter((service) => service.value);
        },
    },
};
</script>

<style lang="scss" scoped>
@import 'UnrenewedServiceList';
</style>
